










import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import AppSwitcher from '@/components/AppSwitcher.vue'
import { IAssetTypeInput } from '@/modules/AccountAsset/interfaces/account-asset-form'
import { AccountAssetType } from '@/modules/AccountAsset/interfaces/account-asset'

@Component({
  components: {
    AppSwitcher
  }
})
export default class AccountAssetFormType extends Vue {
  @Prop({ type: Object as () => IAssetTypeInput }) value!: IAssetTypeInput

  active = 0

  options = ['Property', 'Vehicle']

  mounted () {
    this.active = this.value.type === AccountAssetType.PROPERTY ? 0 : 1
  }

  @Watch('value.type', { deep: true })
  onTypeChanged (val: AccountAssetType) {
    if (!val || this.$R.isEmpty(val)) {
      this.active = 0
      return
    }
    const idx = this.options.findIndex(opt => opt === val)
    this.active = idx
  }

  @Watch('active')
  @Emit('change')
  onSelectionChanged (val: number) {
    return val
  }

  validate () {
    return true
  }
}
